import * as babylon from "@babylonjs/core";

import { BabylonState, BabylonTheme } from "../state";

export function onSetTheme(state: BabylonState, theme: BabylonTheme) {
  const scene = state.context.scene;
  scene.clearColor = theme.backgroundColor;
  scene.fogColor = new babylon.Color3(
    theme.backgroundColor.r,
    theme.backgroundColor.g,
    theme.backgroundColor.b,
  );
}
